import React from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import EditIcon from '@mui/icons-material/Edit';
import PrintIcon from '@mui/icons-material/Print';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

const DividerText = styled('div')(({ theme }) => ({
  position: 'absolute',
  height: '44px',
  top: '2px',
  paddingRight: '8px',
  backgroundColor: '#fff',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
}));

function EnhancedDivider({ readOnly, title, editButtonHint = '', onEditBottonClick, printButtonHint = '', onPrintBottonClick }) {
  return (
    <Grid item sx={{ marginTop: '20px' }} xs={12} sm={12} md={12} style={{ position: 'relative' }} >
      <Divider sx={{ mt: '8px', mb: '0px' }} />
      <DividerText readOnly={readOnly}>
        <Typography color="textSecondary" variant="caption">
          {title}
        </Typography>
        {!readOnly && <Tooltip title={editButtonHint}>
          <IconButton onClick={onEditBottonClick} size="large">
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>}
        {!!onPrintBottonClick && <Tooltip title={printButtonHint}>
          <IconButton onClick={onPrintBottonClick} size="large">
            <PrintIcon fontSize="small" />
          </IconButton>
        </Tooltip>}
      </DividerText>
    </Grid>
  )
}

EnhancedDivider.propTypes = {
  readOnly: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  editButtonHint: PropTypes.string,
  onEditBottonClick: PropTypes.func,
  printButtonHint: PropTypes.string,
  onPrintBottonClick: PropTypes.func,
}

export default EnhancedDivider;